import { render, staticRenderFns } from "./VDialogLoader.vue?vue&type=template&id=0f517d28"
import script from "./VDialogLoader.vue?vue&type=script&lang=js"
export * from "./VDialogLoader.vue?vue&type=script&lang=js"
import style0 from "./VDialogLoader.vue?vue&type=style&index=0&id=0f517d28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VProgressCircular})
